import { IBackupSettings, IGeneralSettings } from '../../types/settings'
import { AppDispatch } from '../../types/store'
import { settingsActions } from '../slices/settingsSlice'

// ============= actions ============ //

export const modifyGeneralSettings =
    (payload: { guid: string; data: IGeneralSettings }) =>
    (dispatch: AppDispatch) => {
        dispatch(settingsActions.modifyGeneralSettings(payload))
    }

    export const modifyBackupSettings =
    (payload: { guid: string; data: IBackupSettings }) =>
    (dispatch: AppDispatch) => {
        dispatch(settingsActions.modifyBackupSettings(payload))
    }